// import { DETAILS_DATA } from '../../constants/app-constants';
import { C2bListingService } from '../../services';
import { mediaFilter } from '../../utils/filter-media';
import types from './types';

const setAuctionDetails = (data) => (
    {
        type: types.SET_AUCTION_DETAILS,
        data
    }
);
const setActiveSlideIndex = (data) => (
    {
        type: types.SET_ACTIVE_SLIDE_NUMBER,
        data
    }
);
const getAuctionDetails = (payload) => (dispatch) => {
    return new Promise((resolve, reject) => {
        C2bListingService.fetchAuctionDetail(payload)
            .then(response => {
                const swiperItems = mediaFilter(response?.data?.detail?.inspectionMedia)?.flat();
                dispatch(setAuctionDetails({ ...response.data?.detail, images: swiperItems }));
                resolve(response.data);
            })
            .catch(error => {
                dispatch(setAuctionDetails(error));
                reject(error);
            });
    });
};

export {
    getAuctionDetails,
    setActiveSlideIndex
};
